import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const propTypes = {
  children: PropTypes.node,
  tag: PropTypes.string,
  className: PropTypes.string,
  cssModule: PropTypes.object,
}

const defaultProps = {
  tag: 'div',
}

const FormFeedback = props => {
  const { className, cssModule, tag: Tag, ...attributes } = props

  const classes = classNames(className, 'form-control-feedback')

  return <Tag {...attributes} className={classes} />
}

FormFeedback.propTypes = propTypes
FormFeedback.defaultProps = defaultProps

export default FormFeedback



// WEBPACK FOOTER //
// ./ui/Form/FormFeedback.js